import i18n from 'i18next';
import ICU from 'i18next-icu';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import bg from 'i18next-icu/locale-data/bg';
import cs from 'i18next-icu/locale-data/cs';
import da from 'i18next-icu/locale-data/da';
import de from 'i18next-icu/locale-data/de';
import en from 'i18next-icu/locale-data/en';
import es from 'i18next-icu/locale-data/es';
import fi from 'i18next-icu/locale-data/fi';
import fr from 'i18next-icu/locale-data/fr';
import he from 'i18next-icu/locale-data/he';
import hu from 'i18next-icu/locale-data/hu';
import id from 'i18next-icu/locale-data/id';
import it from 'i18next-icu/locale-data/it';
import ja from 'i18next-icu/locale-data/ja';
import ko from 'i18next-icu/locale-data/ko';
import nb from 'i18next-icu/locale-data/nb';
import nl from 'i18next-icu/locale-data/nl';
import pl from 'i18next-icu/locale-data/pl';
import pt from 'i18next-icu/locale-data/pt';
import ru from 'i18next-icu/locale-data/ru';
import sv from 'i18next-icu/locale-data/sv';
import th from 'i18next-icu/locale-data/th';
import tr from 'i18next-icu/locale-data/tr';
import vi from 'i18next-icu/locale-data/vi';
import zh from 'i18next-icu/locale-data/zh';

import 'moment/locale/bg';
import 'moment/locale/cs';
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/he';
import 'moment/locale/hu';
import 'moment/locale/id';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/nb';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/sv';
import 'moment/locale/th';
import 'moment/locale/tr';
import 'moment/locale/vi';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-hk';

import * as locales from '../../locales';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(
    new ICU({
      localeData: [bg, cs, da, de, en, es, fi, fr, he, hu, id, it, ja, ko, nb, nl, pl, pt, ru, sv, th, tr, vi, zh],
    }),
  )
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en-US',
    debug: process.env.NODE_ENV === 'development',
    resources: {
      // German
      de: {
        chatbot: { ...locales.deChatbot },
        configuration: { ...locales.deConfiguration },
        contentViewer: { ...locales.deContentViewer },
        playerDashboard: { ...locales.dePlayerDashboard },
        reporting: { ...locales.deReporting },
        messages: { ...locales.deMessages },
        campaignBuilder: { ...locales.deCampaignBuilder },
        catalog: { ...locales.deCatalog },
        audience: { ...locales.deAudience },
        shared: { ...locales.deShared },
        userManagement: { ...locales.deUserManagement },
        companies: { ...locales.deCompanies },
        lsAdmins: { ...locales.deLsAdmins },
        participantDashboard: { ...locales.deParticipantDashboard },
        sidebar: { ...locales.deSidebar },
      },
      // English
      'en-US': {
        chatbot: { ...locales.enChatbot },
        configuration: { ...locales.enConfiguration },
        contentViewer: { ...locales.enContentViewer },
        playerDashboard: { ...locales.enPlayerDashboard },
        reporting: { ...locales.enReporting },
        messages: { ...locales.enMessages },
        campaignBuilder: { ...locales.enCampaignBuilder },
        catalog: { ...locales.enCatalog },
        audience: { ...locales.enAudience },
        shared: { ...locales.enShared },
        userManagement: { ...locales.enUserManagement },
        companies: { ...locales.enCompanies },
        lsAdmins: { ...locales.enLsAdmins },
        participantDashboard: { ...locales.enParticipantDashboard },
        sidebar: { ...locales.enSidebar },
      },
      // Spanish (Fallback)
      es: {
        configuration: { ...locales.esMXConfiguration },
        contentViewer: { ...locales.esESContentViewer },
        playerDashboard: { ...locales.esESPlayerDashboard },
        reporting: { ...locales.esMXReporting },
        messages: { ...locales.esESMessages },
        campaignBuilder: { ...locales.esMXCampaignBuilder },
        catalog: { ...locales.esMXCatalog },
        audience: { ...locales.esMXAudience },
        shared: { ...locales.esESShared },
        userManagement: { ...locales.esMXUserManagement },
        companies: { ...locales.esMXCompanies },
        lsAdmins: { ...locales.esMXLsAdmins },
        participantDashboard: { ...locales.esESParticipantDashboard },
        sidebar: { ...locales.esMXSidebar },
      },
      // Spanish (Spain)
      'es-ES': {
        configuration: { ...locales.esMXConfiguration },
        contentViewer: { ...locales.esESContentViewer },
        playerDashboard: { ...locales.esESPlayerDashboard },
        reporting: { ...locales.esMXReporting },
        messages: { ...locales.esESMessages },
        campaignBuilder: { ...locales.esMXCampaignBuilder },
        catalog: { ...locales.esMXCatalog },
        audience: { ...locales.esMXAudience },
        shared: { ...locales.esESShared },
        userManagement: { ...locales.esMXUserManagement },
        companies: { ...locales.esMXCompanies },
        lsAdmins: { ...locales.esMXLsAdmins },
        participantDashboard: { ...locales.esESParticipantDashboard },
        sidebar: { ...locales.esMXSidebar },
      },
      // Spanish (Mexico)
      'es-MX': {
        configuration: { ...locales.esMXConfiguration },
        contentViewer: { ...locales.esMXContentViewer },
        playerDashboard: { ...locales.esMXPlayerDashboard },
        reporting: { ...locales.esMXReporting },
        messages: { ...locales.esMXMessages },
        campaignBuilder: { ...locales.esMXCampaignBuilder },
        catalog: { ...locales.esMXCatalog },
        audience: { ...locales.esMXAudience },
        shared: { ...locales.esMXShared },
        userManagement: { ...locales.esMXUserManagement },
        companies: { ...locales.esMXCompanies },
        lsAdmins: { ...locales.esMXLsAdmins },
        participantDashboard: { ...locales.esMXParticipantDashboard },
        sidebar: { ...locales.esMXSidebar },
      },
      // French
      fr: {
        configuration: { ...locales.frConfiguration },
        contentViewer: { ...locales.frContentViewer },
        playerDashboard: { ...locales.frPlayerDashboard },
        reporting: { ...locales.frReporting },
        messages: { ...locales.frMessages },
        campaignBuilder: { ...locales.frCampaignBuilder },
        catalog: { ...locales.frCatalog },
        audience: { ...locales.frAudience },
        shared: { ...locales.frShared },
        userManagement: { ...locales.frUserManagement },
        companies: { ...locales.frCompanies },
        lsAdmins: { ...locales.frLsAdmins },
        participantDashboard: { ...locales.frParticipantDashboard },
        sidebar: { ...locales.frSidebar },
      },
      // French (Canadian)
      'fr-CA': {
        configuration: { ...locales.frCAConfiguration },
        contentViewer: { ...locales.frCAContentViewer },
        playerDashboard: { ...locales.frCAPlayerDashboard },
        reporting: { ...locales.frCAReporting },
        messages: { ...locales.frCAMessages },
        campaignBuilder: { ...locales.frCACampaignBuilder },
        catalog: { ...locales.frCACatalog },
        audience: { ...locales.frCAAudience },
        shared: { ...locales.frCAShared },
        userManagement: { ...locales.frCAUserManagement },
        companies: { ...locales.frCACompanies },
        lsAdmins: { ...locales.frCALsAdmins },
        participantDashboard: { ...locales.frCAParticipantDashboard },
        sidebar: { ...locales.frCASidebar },
      },
      // Indonesian
      'id-ID': {
        contentViewer: { ...locales.idIDContentViewer },
        playerDashboard: { ...locales.idIDPlayerDashboard },
        messages: { ...locales.idIDMessages },
        shared: { ...locales.idIDShared },
        participantDashboard: { ...locales.idIDParticipantDashboard },
      },
      // Italian
      'it-IT': {
        configuration: { ...locales.itITConfiguration },
        contentViewer: { ...locales.itITContentViewer },
        playerDashboard: { ...locales.itITPlayerDashboard },
        reporting: { ...locales.itBRReporting },
        messages: { ...locales.itITMessages },
        campaignBuilder: { ...locales.itITCampaignBuilder },
        catalog: { ...locales.itITCatalog },
        audience: { ...locales.itITAudience },
        shared: { ...locales.itITShared },
        userManagement: { ...locales.itITUserManagement },
        companies: { ...locales.itITCompanies },
        lsAdmins: { ...locales.itITLsAdmins },
        participantDashboard: { ...locales.itITParticipantDashboard },
        sidebar: { ...locales.itITSidebar },
      },
      // Japanese
      ja: {
        configuration: { ...locales.jaConfiguration },
        contentViewer: { ...locales.jaContentViewer },
        playerDashboard: { ...locales.jaPlayerDashboard },
        reporting: { ...locales.jaReporting },
        messages: { ...locales.jaMessages },
        campaignBuilder: { ...locales.jaCampaignBuilder },
        catalog: { ...locales.jaCatalog },
        audience: { ...locales.jaAudience },
        shared: { ...locales.jaShared },
        userManagement: { ...locales.jaUserManagement },
        companies: { ...locales.jaCompanies },
        lsAdmins: { ...locales.jaLsAdmins },
        participantDashboard: { ...locales.jaParticipantDashboard },
        sidebar: { ...locales.jaSidebar },
      },
      // Dutch
      'nl-NL': {
        configuration: { ...locales.nlNLConfiguration },
        contentViewer: { ...locales.nlNLContentViewer },
        playerDashboard: { ...locales.nlNLPlayerDashboard },
        reporting: { ...locales.nlBRReporting },
        messages: { ...locales.nlNLMessages },
        campaignBuilder: { ...locales.nlNLCampaignBuilder },
        catalog: { ...locales.nlNLCatalog },
        audience: { ...locales.nlNLAudience },
        shared: { ...locales.nlNLShared },
        userManagement: { ...locales.nlNLUserManagement },
        companies: { ...locales.nlNLCompanies },
        lsAdmins: { ...locales.nlNLLsAdmins },
        participantDashboard: { ...locales.nlNLParticipantDashboard },
        sidebar: { ...locales.nlNLSidebar },
      },
      // Polish
      'pl-PL': {
        configuration: { ...locales.plPLConfiguration },
        contentViewer: { ...locales.plPLContentViewer },
        playerDashboard: { ...locales.plPLPlayerDashboard },
        reporting: { ...locales.plBRReporting },
        messages: { ...locales.plPLMessages },
        campaignBuilder: { ...locales.plPLCampaignBuilder },
        catalog: { ...locales.plPLCatalog },
        audience: { ...locales.plPLAudience },
        shared: { ...locales.plPLShared },
        userManagement: { ...locales.plPLUserManagement },
        companies: { ...locales.plPLCompanies },
        lsAdmins: { ...locales.plPLLsAdmins },
        participantDashboard: { ...locales.plPLParticipantDashboard },
        sidebar: { ...locales.plPLSidebar },
      },
      // Portuguese (Portugal)
      pt: {
        configuration: { ...locales.ptBRConfiguration },
        contentViewer: { ...locales.ptContentViewer },
        playerDashboard: { ...locales.ptPlayerDashboard },
        reporting: { ...locales.ptBRReporting },
        messages: { ...locales.ptMessages },
        campaignBuilder: { ...locales.ptBRCampaignBuilder },
        catalog: { ...locales.ptBRCatalog },
        audience: { ...locales.ptBRAudience },
        shared: { ...locales.ptShared },
        userManagement: { ...locales.ptBRUserManagement },
        companies: { ...locales.ptBRCompanies },
        lsAdmins: { ...locales.ptBRLsAdmins },
        participantDashboard: { ...locales.ptParticipantDashboard },
        sidebar: { ...locales.ptBRSidebar },
      },
      // Portuguese (Brazil)
      'pt-BR': {
        configuration: { ...locales.ptBRConfiguration },
        contentViewer: { ...locales.ptBRContentViewer },
        playerDashboard: { ...locales.ptBRPlayerDashboard },
        reporting: { ...locales.ptBRReporting },
        messages: { ...locales.ptBRMessages },
        campaignBuilder: { ...locales.ptBRCampaignBuilder },
        catalog: { ...locales.ptBRCatalog },
        audience: { ...locales.ptBRAudience },
        shared: { ...locales.ptBRShared },
        userManagement: { ...locales.ptBRUserManagement },
        companies: { ...locales.ptBRCompanies },
        lsAdmins: { ...locales.ptBRLsAdmins },
        participantDashboard: { ...locales.ptBRParticipantDashboard },
        sidebar: { ...locales.ptBRSidebar },
      },
      // Turkish - fallback
      tr: {
        configuration: { ...locales.trConfiguration },
        contentViewer: { ...locales.trContentViewer },
        playerDashboard: { ...locales.trPlayerDashboard },
        reporting: { ...locales.trReporting },
        messages: { ...locales.trMessages },
        campaignBuilder: { ...locales.trCampaignBuilder },
        catalog: { ...locales.trCatalog },
        audience: { ...locales.trAudience },
        shared: { ...locales.trShared },
        userManagement: { ...locales.trUserManagement },
        companies: { ...locales.trCompanies },
        lsAdmins: { ...locales.trLsAdmins },
        participantDashboard: { ...locales.trParticipantDashboard },
        sidebar: { ...locales.trSidebar },
      },
      // Turkish
      'tr-TR': {
        configuration: { ...locales.trConfiguration },
        contentViewer: { ...locales.trContentViewer },
        playerDashboard: { ...locales.trPlayerDashboard },
        reporting: { ...locales.trReporting },
        messages: { ...locales.trMessages },
        campaignBuilder: { ...locales.trCampaignBuilder },
        catalog: { ...locales.trCatalog },
        audience: { ...locales.trAudience },
        shared: { ...locales.trShared },
        userManagement: { ...locales.trUserManagement },
        companies: { ...locales.trCompanies },
        lsAdmins: { ...locales.trLsAdmins },
        participantDashboard: { ...locales.trParticipantDashboard },
        sidebar: { ...locales.trSidebar },
      },
      // Chinese (Simplified) - fallback
      zh: {
        configuration: { ...locales.zhCNConfiguration },
        contentViewer: { ...locales.zhCNContentViewer },
        playerDashboard: { ...locales.zhCNPlayerDashboard },
        reporting: { ...locales.zhCNReporting },
        messages: { ...locales.zhCNMessages },
        campaignBuilder: { ...locales.zhCNCampaignBuilder },
        catalog: { ...locales.zhCNCatalog },
        audience: { ...locales.zhCNAudience },
        shared: { ...locales.zhCNShared },
        userManagement: { ...locales.zhCNUserManagement },
        companies: { ...locales.zhCNCompanies },
        lsAdmins: { ...locales.zhCNLsAdmins },
        participantDashboard: { ...locales.zhCNParticipantDashboard },
        sidebar: { ...locales.zhCNSidebar },
      },
      // Chinese (Simplified)
      'zh-Hans': {
        configuration: { ...locales.zhCNConfiguration },
        contentViewer: { ...locales.zhCNContentViewer },
        playerDashboard: { ...locales.zhCNPlayerDashboard },
        reporting: { ...locales.zhCNReporting },
        messages: { ...locales.zhCNMessages },
        campaignBuilder: { ...locales.zhCNCampaignBuilder },
        catalog: { ...locales.zhCNCatalog },
        audience: { ...locales.zhCNAudience },
        shared: { ...locales.zhCNShared },
        userManagement: { ...locales.zhCNUserManagement },
        companies: { ...locales.zhCNCompanies },
        lsAdmins: { ...locales.zhCNLsAdmins },
        participantDashboard: { ...locales.zhCNParticipantDashboard },
        sidebar: { ...locales.zhCNSidebar },
      },
      // Chinese (Traditional)
      'zh-Hant': {
        configuration: { ...locales.zhHKConfiguration },
        contentViewer: { ...locales.zhHKContentViewer },
        playerDashboard: { ...locales.zhHKPlayerDashboard },
        reporting: { ...locales.zhHKReporting },
        messages: { ...locales.zhHKMessages },
        campaignBuilder: { ...locales.zhHKCampaignBuilder },
        catalog: { ...locales.zhHKCatalog },
        audience: { ...locales.zhHKAudience },
        shared: { ...locales.zhHKShared },
        userManagement: { ...locales.zhHKUserManagement },
        companies: { ...locales.zhHKCompanies },
        lsAdmins: { ...locales.zhHKLsAdmins },
        participantDashboard: { ...locales.zhHKParticipantDashboard },
        sidebar: { ...locales.zhHKSidebar },
      },
      // Chinese (Traditional) - fallback
      'zh-hk': {
        configuration: { ...locales.zhHKConfiguration },
        contentViewer: { ...locales.zhHKContentViewer },
        playerDashboard: { ...locales.zhHKPlayerDashboard },
        reporting: { ...locales.zhHKReporting },
        messages: { ...locales.zhHKMessages },
        campaignBuilder: { ...locales.zhHKCampaignBuilder },
        catalog: { ...locales.zhHKCatalog },
        audience: { ...locales.zhHKAudience },
        shared: { ...locales.zhHKShared },
        userManagement: { ...locales.zhHKUserManagement },
        companies: { ...locales.zhHKCompanies },
        lsAdmins: { ...locales.zhHKLsAdmins },
        participantDashboard: { ...locales.zhHKParticipantDashboard },
        sidebar: { ...locales.zhHKSidebar },
      },
      // Bulgarian
      bg: {
        contentViewer: { ...locales.bgContentViewer },
        companies: { ...locales.bgCompanies },
        playerDashboard: { ...locales.bgPlayerDashboard },
        participantDashboard: { ...locales.bgParticipantDashboard },
        shared: { ...locales.bgShared },
      },
      // Czech
      cs: {
        contentViewer: { ...locales.csContentViewer },
        companies: { ...locales.csCompanies },
        playerDashboard: { ...locales.csPlayerDashboard },
        participantDashboard: { ...locales.csParticipantDashboard },
        shared: { ...locales.csShared },
      },
      // Hungarian
      hu: {
        contentViewer: { ...locales.huContentViewer },
        companies: { ...locales.huCompanies },
        playerDashboard: { ...locales.huPlayerDashboard },
        participantDashboard: { ...locales.huParticipantDashboard },
        shared: { ...locales.huShared },
      },
      // Korean
      ko: {
        contentViewer: { ...locales.koContentViewer },
        companies: { ...locales.koCompanies },
        playerDashboard: { ...locales.koPlayerDashboard },
        participantDashboard: { ...locales.koParticipantDashboard },
        shared: { ...locales.koShared },
      },
      // Vietnamese
      vi: {
        contentViewer: { ...locales.viContentViewer },
        companies: { ...locales.viCompanies },
        playerDashboard: { ...locales.viPlayerDashboard },
        participantDashboard: { ...locales.viParticipantDashboard },
        shared: { ...locales.viShared },
      },
      // Russian
      ru: {
        contentViewer: { ...locales.ruContentViewer },
        companies: { ...locales.ruCompanies },
        playerDashboard: { ...locales.ruPlayerDashboard },
        participantDashboard: { ...locales.ruParticipantDashboard },
        shared: { ...locales.ruShared },
      },
      // Thai
      'th-TH': {
        contentViewer: { ...locales.thContentViewer },
        messages: { ...locales.thMessages },
        playerDashboard: { ...locales.thPlayerDashboard },
        participantDashboard: { ...locales.thParticipantDashboard },
        shared: { ...locales.thShared },
      },
      // Swedish
      sv: {
        contentViewer: { ...locales.svContentViewer },
        messages: { ...locales.svMessages },
        playerDashboard: { ...locales.svPlayerDashboard },
        participantDashboard: { ...locales.svParticipantDashboard },
        shared: { ...locales.svShared },
      },
      // Norwegian
      'nb-NO': {
        contentViewer: { ...locales.nbContentViewer },
        messages: { ...locales.nbMessages },
        playerDashboard: { ...locales.nbPlayerDashboard },
        participantDashboard: { ...locales.nbParticipantDashboard },
        shared: { ...locales.nbShared },
      },
      // Danish
      da: {
        contentViewer: { ...locales.daContentViewer },
        messages: { ...locales.daMessages },
        playerDashboard: { ...locales.daPlayerDashboard },
        participantDashboard: { ...locales.daParticipantDashboard },
        shared: { ...locales.daShared },
      },
      // Finnish
      fi: {
        contentViewer: { ...locales.fiContentViewer },
        messages: { ...locales.fiMessages },
        playerDashboard: { ...locales.fiPlayerDashboard },
        participantDashboard: { ...locales.fiParticipantDashboard },
        shared: { ...locales.fiShared },
      },
      // Hebrew
      he: {
        contentViewer: { ...locales.heContentViewer },
        messages: { ...locales.heMessages },
        playerDashboard: { ...locales.hePlayerDashboard },
        participantDashboard: { ...locales.heParticipantDashboard },
        shared: { ...locales.heShared },
      },
      // Romanian
      ro: {
        contentViewer: { ...locales.roContentViewer },
        messages: { ...locales.roMessages },
        playerDashboard: { ...locales.roPlayerDashboard },
        participantDashboard: { ...locales.roParticipantDashboard },
        shared: { ...locales.roShared },
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      prefix: '{{',
      suffix: '}}',
    },
    react: {
      wait: true,
    },
    detection: {
      order: ['querystring', 'localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'userLanguage',
      caches: ['localStorage'],
    },
  });

export default i18n;
